export const isGoCardlessEnabled = () =>
  process.env.ENABLE_GOCARDLESS?.trim().toLowerCase() === 'true'
